import { Alert as MuiAlert, AlertTitle, Snackbar } from '@mui/material';
import { FC } from 'react';

interface AlertProps {
  open: boolean;
  onClose?: () => void;
  message: string;
  type: 'success' | 'info' | 'warning' | 'error';
}

const Alert: FC<AlertProps> = ({ open, onClose, message, type }) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      autoHideDuration={type === 'success' ? 3000 : null}
      onClose={onClose}
    >
      <MuiAlert severity={type} variant='filled' onClose={onClose}>
        {message && <AlertTitle>{message}</AlertTitle>}
      </MuiAlert>
    </Snackbar>
  );
};

export default Alert;
